let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("aKc3I")).then(() => parcelRequire('5vxzP'));